import Link from "next/link";
import { FiLogOut, FiUser } from "react-icons/fi";
import { LuTicket } from "react-icons/lu";
import { withRegionPath } from "@/utils/session";
import styles from "./AccountMenu.module.css";
import { FaUser } from "react-icons/fa";
import { GiTicket } from "react-icons/gi";
import Image from "next/image";

export const ACCOUNT_MENU_ITEMS = [
  {
    id: "profile",
    label: "My Profile",
    description: "Manage your profile and more",
    href: "/profile",
    icon: <FaUser size={18} />,
  },
  {
    id: "bookings",
    label: "My Bookings",
    description: "Check your all bookings",
    href: "/profile?section=bookings",
    icon: <GiTicket size={22} />,
  },
  // {
  //   id: "logout",
  //   label: "Log Out",
  //   icon: FiLogOut,
  //   action: "logout",
  // },
];

export default function AccountMenu({ variant = "popover", onItemClick }) {
  const handleClick = (item, event) => {
    if (item.action === "logout") {
      event.preventDefault();
      onItemClick?.(item);
      return;
    }

    onItemClick?.(item);
  };

  return (
    <nav
      className={`${styles.menu} ${variant === "drawer" ? styles.menuDrawer : styles.menuPopover}`}
      aria-label="Account menu"
    >
      {ACCOUNT_MENU_ITEMS.map((item) => {
        const Icon = item.icon;
        const content = (
          <>
            <span className={styles.iconWrap}>
              {Icon}
            </span>
            <span className={styles.copy}>
              <span className={styles.label}>{item.label}</span>
              {item.description ? (
                <span className={styles.description}>{item.description}</span>
              ) : null}
            </span>
          </>
        );
        return (
          <Link
            key={item.id}
            href={withRegionPath(item.href)}
            className={styles.item}
            onClick={() => onItemClick?.(item)}
          >
            {content}
          </Link>
        );
      })}

      <button
        type="button"
        className={styles.item}
        onClick={(event) => handleClick({
          id: "logout",
          label: "Log Out",
          icon: FiLogOut,
          action: "logout",
        }, event)}
      >
        <span className={styles.iconWrap}>
          <Image src={"/assets/icons/logout.svg"} height={20} width={20} />
        </span>
        <span className={styles.copy}>
          <span className={styles.label}>Logout</span>
        </span>
      </button>
    </nav>
  );
}
